/**
 * Generated by orval v6.12.1 🍺
 * Do not edit manually.
 * Platz API
 * Platz API boi
 * OpenAPI spec version: 2.0
 */
import { useQuery, useMutation } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type {
  CreateSpotifyTokenResponse,
  PlatzApiError,
  CreateSpotifyTokenRequest,
  SpotifyTrackSourceOptionView,
} from ".././model";
import { customInstance } from "../../../axios";
import type { ErrorType, BodyType } from "../../../axios";

export const createSpotifyOAuthToken = (
  createSpotifyTokenRequest: BodyType<CreateSpotifyTokenRequest>
) => {
	console.log("creating token right here!!!", createSpotifyTokenRequest);
  return customInstance<CreateSpotifyTokenResponse>({
    url: `/api/music/spotify-token`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: createSpotifyTokenRequest,
  });
};

export type CreateSpotifyOAuthTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSpotifyOAuthToken>>
>;
export type CreateSpotifyOAuthTokenMutationBody =
  BodyType<CreateSpotifyTokenRequest>;
export type CreateSpotifyOAuthTokenMutationError = ErrorType<PlatzApiError>;

export const useCreateSpotifyOAuthToken = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpotifyOAuthToken>>,
    TError,
    { data: BodyType<CreateSpotifyTokenRequest> },
    TContext
  >;
}) => {
	console.log("wtfffffffff");
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSpotifyOAuthToken>>,
    { data: BodyType<CreateSpotifyTokenRequest> }
  > = (props) => {
    const { data } = props ?? {};
	console.log("wtf 222222222222222");

    return createSpotifyOAuthToken(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof createSpotifyOAuthToken>>,
    TError,
    { data: BodyType<CreateSpotifyTokenRequest> },
    TContext
  >(mutationFn, mutationOptions);
};
export const getSpotifyTopTracks = (signal?: AbortSignal) => {
  return customInstance<SpotifyTrackSourceOptionView[]>({
    url: `/api/music/spotify-top-tracks`,
    method: "get",
    signal,
  });
};

export const getGetSpotifyTopTracksQueryKey = () => [
  `/api/music/spotify-top-tracks`,
];

export type GetSpotifyTopTracksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSpotifyTopTracks>>
>;
export type GetSpotifyTopTracksQueryError = ErrorType<PlatzApiError>;

export const useGetSpotifyTopTracks = <
  TData = Awaited<ReturnType<typeof getSpotifyTopTracks>>,
  TError = ErrorType<PlatzApiError>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSpotifyTopTracks>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSpotifyTopTracksQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSpotifyTopTracks>>
  > = ({ signal }) => getSpotifyTopTracks(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getSpotifyTopTracks>>,
    TError,
    TData
  >({ queryKey, queryFn, ...queryOptions }) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const getSpotifyLoginUrl = (signal?: AbortSignal) => {
  return customInstance<string>({
    url: `/api/music/spotify-oauth`,
    method: "get",
    signal,
  });
};

export const getGetSpotifyLoginUrlQueryKey = () => [`/api/music/spotify-oauth`];

export type GetSpotifyLoginUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSpotifyLoginUrl>>
>;
export type GetSpotifyLoginUrlQueryError = ErrorType<PlatzApiError>;

export const useGetSpotifyLoginUrl = <
  TData = Awaited<ReturnType<typeof getSpotifyLoginUrl>>,
  TError = ErrorType<PlatzApiError>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSpotifyLoginUrl>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSpotifyLoginUrlQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSpotifyLoginUrl>>
  > = ({ signal }) => getSpotifyLoginUrl(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getSpotifyLoginUrl>>,
    TError,
    TData
  >({ queryKey, queryFn, ...queryOptions }) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};
